import { useState } from "react";
import { salvarColunasCarteira } from "services/api/AppWeb_Lead/colunas-carteira";
import { ColumnConfig, getDefaultColumns } from "../constants";

const STORAGE_KEY = "tableColumns";

export function useColumnConfig(
  codigoCargo: string | null,
  apiColumns?: string[],
  usuarioGerenteOnline = false
) {
  const defaultColumns = getDefaultColumns(codigoCargo, usuarioGerenteOnline);

  const [columns, setColumns] = useState<ColumnConfig[]>(() => {
    // Prioridade: API > localStorage > default
    if (apiColumns && apiColumns.length > 0) {
      return defaultColumns.map((col) => ({
        ...col,
        visible: col.alwaysVisible || apiColumns.includes(col.id),
      }));
    }
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      const parsed = JSON.parse(saved);
      return defaultColumns.map((defaultCol) => {
        const savedCol = parsed.find(
          (col: ColumnConfig) => col.id === defaultCol.id
        );
        return savedCol
          ? { ...defaultCol, visible: savedCol.visible }
          : defaultCol;
      });
    }
    return defaultColumns;
  });

  const [tempColumns, setTempColumns] = useState<ColumnConfig[]>(columns);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isOpen = Boolean(anchorEl);

  const open = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setTempColumns(columns);
  };

  const close = () => setAnchorEl(null);

  const toggleTempColumn = (columnId: string) => {
    setTempColumns((prev) =>
      prev.map((col) =>
        col.id === columnId ? { ...col, visible: !col.visible } : col
      )
    );
  };

  const reset = () => {
    setTempColumns(defaultColumns.map((col) => ({ ...col })));
  };

  const save = () => {
    setColumns(tempColumns);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(tempColumns));
    const visibleIds = tempColumns
      .filter((col) => col.visible)
      .map((col) => col.id);
    salvarColunasCarteira(visibleIds).catch(() => {});
    close();
  };

  const visibleColumns = columns.filter((col) => col.visible);

  return {
    columns,
    tempColumns,
    visibleColumns,
    anchorEl,
    isOpen,
    open,
    close,
    toggleTempColumn,
    reset,
    save,
    codigoCargo,
    defaultColumns,
  };
}
